module.exports = __webpack_public_path__ + "1c747e941f28e4aae646aa4f8940e82c.pdf";